// extracted by mini-css-extract-plugin
module.exports = {"card":"AgendaItemRelatedCard_card__2yVmT","meetingLink":"AgendaItemRelatedCard_meetingLink__2xC6P","agendaItemLink":"AgendaItemRelatedCard_agendaItemLink__3Wj7j"};